import client from "../client";
import { postSubscriptionConfig } from "./postSubscriptionConfig";

const postSubscription = (authorization?: string, origin?: string, xForwardedFor?: string) => {
  return client({
    ...postSubscriptionConfig(authorization, origin, xForwardedFor),
  });
};

export default { postSubscription };
